<div class="mx-auto max-w-6xl px-4 py-6 sm:px-5 sm:py-8">
    <header class="mb-6 space-y-0.5">
        <h1 class="text-base font-semibold text-slate-900 !text-4xl !leading-tight !font-bold">Il tuo carrello</h1>
        <p class="text-sm text-slate-500">Rivedi gli articoli prima del checkout.</p>
    </header>

    <ng-container *ngIf="cartProducts.length > 0; else emptyCart">
        <div
            class="overflow-hidden rounded-2xl border border-slate-200/90 bg-white shadow-sm ring-1 ring-slate-900/5">
            <div class="divide-y divide-slate-100">
                <article *ngFor="let product of cartProducts"
                    class="flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:gap-5 sm:p-5">
                    <div class="flex flex-1 items-start gap-4">
                        <div
                            class="relative h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-slate-100 sm:h-24 sm:w-24">
                            <img [src]="product.imageUrl" [attr.alt]="product.name || 'Prodotto'"
                                class="h-full w-full object-cover" />
                            <span
                                class="absolute -bottom-1 -right-1 flex h-6 min-w-[1.5rem] items-center justify-center rounded-md bg-slate-900/80 px-1.5 text-xs font-bold text-white">
                                {{ product.quantity }}
                            </span>
                        </div>
                        <div class="min-w-0 flex-1">
                            <h2 class="text-sm font-semibold leading-snug text-slate-900">
                                {{ product.name }}
                            </h2>
                            <p class="mt-1 text-xs text-slate-500">
                                <span class="font-medium text-slate-600">{{ product.size }}</span>
                                <span class="text-slate-300"> · </span>
                                <span>{{ product.color }}</span>
                            </p>
                            <p class="mt-2 text-xs text-slate-400 sm:hidden">
                                Quantità: <span class="font-medium text-slate-600">{{ product.quantity }}</span>
                            </p>
                        </div>
                    </div>

                    <div class="flex items-center justify-between gap-4 border-t border-slate-100 pt-4 sm:border-0 sm:pt-0">
                        <div class="text-left sm:text-right">
                            <p class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Subtotale</p>
                            <p class="mt-0.5 text-base font-semibold tabular-nums text-slate-900">
                                {{ (product.price * product.quantity) | currency:'EUR':true }}
                            </p>
                        </div>
                        <button type="button" (click)="removeCartProducts(product)"
                            class="inline-flex items-center justify-center rounded-lg border border-red-200 bg-white p-2.5 text-red-600 shadow-sm transition hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500/25"
                            [attr.aria-label]="'Rimuovi ' + (product.name || 'prodotto')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                class="bi bi-trash-fill shrink-0" viewBox="0 0 16 16" aria-hidden="true">
                                <path
                                    d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                            </svg>
                        </button>
                    </div>
                </article>
            </div>

            <div class="space-y-4 border-t border-slate-100 bg-slate-50/50 px-4 py-5 sm:px-6">
                <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        <p class="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Totale carrello</p>
                        <p class="mt-1 text-xl font-semibold tabular-nums text-slate-900">
                            {{ cartSubTotal(cartProducts) | currency:'EUR':true }}
                        </p>
                    </div>
                    <button type="button" (click)="goTo('shop/checkout')"
                        class="inline-flex w-full items-center justify-center rounded-lg px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2 sm:w-auto"
                        style="background-color: var(--primary-color)">
                        Procedi al checkout
                    </button>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-template #emptyCart>
        <div
            class="rounded-2xl border border-slate-200/90 bg-white px-6 py-12 text-center shadow-sm ring-1 ring-slate-900/5 sm:py-16">
            <p class="text-sm font-medium text-slate-900">Il tuo carrello è attualmente vuoto.</p>
            <p class="mt-2 text-sm text-slate-500">Aggiungi prodotti dallo shop per iniziare.</p>
            <button type="button" (click)="goTo('shop')"
                class="mt-6 inline-flex items-center justify-center rounded-lg px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition focus:outline-none focus:ring-2 focus:ring-[var(--primary-color)] focus:ring-offset-2"
                style="background-color: var(--primary-color)">
                Vai allo shop
            </button>
        </div>
    </ng-template>
</div>
